export const tarkovTitleSlug = 'escape-from-tarkov' as const;
